import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import ROASPNOCalculator from "./pages/ROASPNOCalculator";
import NotFound from "./components/NotFound";
import "./App.css";
import WeatherComp from "./components/WeatherComp";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedAnalyses from "./pages/ProtectedAnalyses";

const App: React.FC = () => {
  return (
    <Router>
      <div className="AppWrapper">
        <div className="MainApp">
          <Navbar />
          <Routes>
            <Route path="/" element={<ROASPNOCalculator />} />
            <Route path="/admin" element={<AdminDashboard />} />{" "}
            <Route path="/roas-pno" element={<ROASPNOCalculator />} />
            <Route path="feed-analysis" element={<ProtectedAnalyses />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <WeatherComp />
      </div>
    </Router>
  );
};

export default App;
